// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"f69977ad","426":"3f6a10b3","969":"89414e98"}[chunkId] + ".chunk.css";
};